import { render, staticRenderFns } from "./industrialDistribution.vue?vue&type=template&id=87897ea6&scoped=true"
import script from "./industrialDistribution.vue?vue&type=script&lang=js"
export * from "./industrialDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87897ea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87897ea6')) {
      api.createRecord('87897ea6', component.options)
    } else {
      api.reload('87897ea6', component.options)
    }
    module.hot.accept("./industrialDistribution.vue?vue&type=template&id=87897ea6&scoped=true", function () {
      api.rerender('87897ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/comps/industrialDistribution.vue"
export default component.exports